/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {AuthInterceptor} from "./auth-interceptor";

/** Class to enroute the HTTP request to the interceptor */
/**
 *
 * @type {{provide: InjectionToken<HttpInterceptor[]>; useClass: AuthInterceptor; multi: boolean}[]}
 */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
